<script>
import eventBus from "../eventBus";
    export default {
        props: ['formMenu', 'role'],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
            removeItem(index)
            {
                this.formMenu.items.splice(index, 1)
            },
        }
    }
</script>

<template>
    <div>
        <div class="card position-relative">

            <div class="card-header">
                <h3 class="card-title">Recettes selectionnés - {{ formMenu.items.length }} </h3>
            </div>

            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                <thead>
                <tr>
                    <th>
                    </th>
                    <th class="text-center w-1"><i class="icon-people"></i></th>
                    <th>Nom</th>
                    <th class="text-center">Catégorie</th>
                    <th class="text-center">Public ?</th>
                    <th class="text-center">Ingrédients</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(recipe, index) in formMenu.items" :key="recipe.id">
                    <td>
                        <button @click.prevent="removeItem( index)" type="button" class="btn btn-outline-danger btn-sm">Supprimer</button>
                    </td>
                    <td class="text-center">
                        {{ recipe.id }} <img v-if="recipe.image" :src="recipe.image" style="width: 48px;height: 48px;padding: 5px;object-fit: cover;" />
                    </td>
                    <td>
                        <a target="_blank" :href="recipe.url">{{ recipe.name }}</a><br>
                        <small v-if="role == 'admin'">{{ recipe.note_env }}/{{ recipe.note_sante }}/{{ recipe.note_social }} </small>
                    </td>
                    <td class="text-center">
                        {{ recipe.category_name }}
                    </td>
                    <td class="text-center">
                        {{ recipe.scope_recipe == 'owner' ? 'Non' : 'Oui' }}
                    </td>
                    <td class="text-center">
                        {{ recipe.ingredients_count }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style scoped>
.position-relative {
    position: relative;
}
/* Overlay full covering */
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7); /* Fond semi-transparent */
    z-index: 10;
}
.spinner-border {
    width: 3rem;
    height: 3rem;
}
</style>
